module.exports = __webpack_public_path__ + "img/sabers-crossed.5c1b5fcb.svg";